import type { AxiosResponse } from 'axios';
import {
  donedealServerGateway,
  donedealServicesGateway,
} from '../api/api-utils/commonApiUtils';
import type {
  CarValuationResponse,
  DealerCarValuationResponse,
  MileageIndicatorApiResponse,
  MileageIndicatorRequest,
} from '../api/types/CarValuationApiTypes';
import type { IncomingHttpHeaders } from 'http';

async function postCarMileageIndicator(
  payload: MileageIndicatorRequest,
  headers?: IncomingHttpHeaders,
): Promise<AxiosResponse<MileageIndicatorApiResponse>> {
  return await donedealServicesGateway.post(
    `/ddapi/v2/vehicle/valuate/mileage-indicator`,
    payload,
    {
      headers: {
        ...headers,
        accept: 'application/json',
      },
    },
  );
}

async function getCarValuation(
  registrationNumber: string,
  mileageInKilometers: string,
  source: string,
  headers: IncomingHttpHeaders,
): Promise<AxiosResponse<CarValuationResponse>> {
  const response: AxiosResponse<CarValuationResponse> =
    await donedealServerGateway.get(
      `/ddapi/v1/vehicle/valuate/${registrationNumber}?mileageInKilometers=${mileageInKilometers}&source=${source}`,
      {
        headers: {
          ...headers,
          accept: 'application/json',
        },
      },
    );

  return response;
}

type postCarValuationArgs = {
  registrationNumber: string;
  mileageInKilometers: string;
  source: string;
  headers: IncomingHttpHeaders;
};
const postCarValuation = async (args: postCarValuationArgs) => {
  const { registrationNumber, mileageInKilometers, source, headers } = args;

  const response = await donedealServerGateway.post(
    '/ddapi/v2/vehicle/valuate/private',
    {
      registrationNumber,
      mileageInKilometers,
      source,
    },
    {
      headers: {
        ...headers,
        accept: 'application/json',
      },
    },
  );

  return response;
};

async function getDealerCarValuation(
  registrationNumber: string,
  mileageInKilometers: string,
  source: string,
  headers: IncomingHttpHeaders,
): Promise<AxiosResponse<DealerCarValuationResponse>> {
  const response: AxiosResponse<DealerCarValuationResponse> =
    await donedealServerGateway.get(
      `/dhapi/v1/vehicle/valuate/${registrationNumber}?mileageInKilometers=${mileageInKilometers}&source=${source}`,
      {
        headers: {
          ...headers,
          accept: 'application/json',
        },
      },
    );

  return response;
}

export const carValuationApi = {
  getCarValuation,
  getDealerCarValuation,
  postCarMileageIndicator,
  postCarValuation,
};
